// imove-behavior: 获取路由path

export default async function(ctx) {
  const { pathname } = ctx.payload;
  return {
    pathname
  };
}